import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const ForbiddenPage = () => {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate('/');
	};

	return (
		<Box
			sx={{
				minHeight: '100vh',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				bgcolor: 'background.default',
				p: 3,
			}}
		>
			<LockOutlinedIcon sx={{ fontSize: 100, color: 'error.main', mb: 2 }} />
			<Typography variant="h2" color="text.primary" gutterBottom>
				403
			</Typography>
			<Typography variant="h5" color="text.secondary" gutterBottom>
				Forbidden - You do not have permission to access this page.
			</Typography>
			<Button variant="contained" color="primary" sx={{ mt: 3 }} onClick={handleGoHome}>
				Go to Home
			</Button>
		</Box>
	);
};

export default ForbiddenPage;
